import script from "./IntroPage.vue?vue&type=script&setup=true&lang=js"
export * from "./IntroPage.vue?vue&type=script&setup=true&lang=js"

import "./IntroPage.vue?vue&type=style&index=0&id=12541bf2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12541bf2"]])

export default __exports__